
export default {
  data() {
    return {
      activeSlide: 0,
      inView: false,
      swiperOptions: {
        centeredSlides: true,
        spaceBetween: 20,
        slidesPerView: 1,
        loop: false,
        pagination: {
          el: ".swiper-work-pagination",
          clickable: true,
        },
        breakpoints: {
          767: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
        },
      },
      options: [
        {
          name: "image",
          label: "Image",
          type: "image",
        },
        {
          name: "title",
          label: "Title",
          type: "text",
        },
      ],
    };
  },
};
